import { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import moment from 'moment/min/moment-with-locales';
import { Modal, OverlayTrigger, Tooltip, Row, Col } from 'react-bootstrap';

//components
import applicationRouter from '~/hoc/applicationRouter';
import withRemoveDialog from '~/hoc/withRemoveDialog';
import withLocalization from '~/hoc/withLocalization';
import PastTimelogModal from './PastTimeLogModal.js';
import ModalEditor from './ModalAccept';
import MultiTaskModalAccept from './MultiTaskModalAccept';
import { OvertimeDisplay, WeeklyOvertimeDisplay } from '../../../components/OvertimeDisplay/OvertimeDisplay';
import GenericList from '~/components/GenericList/GenericList';
import GenericFilter from '../../../components/GenericList/GenericFilter.js';
import GPSInfo from './GPSInfo';
import AbsenceVacationMassTimelogApproval from '../../../components/GenericModal/AbsenceVacationMassTimelogApproval.js';
import TimelogConflictsModal from './TimelogConflictsModal';
import EditTimesheetTimeModal from './EditTimesheetTimeModal';
import UserPromptModal from '../../../components/GenericModal/userPromptModal/index.js';

// Elements
import Button from '../../../components/CustomButton/CustomButton.jsx';
import LoadingSpinner from '~/elements/LoadingSpinner';

//configs
import { getUploadedFileURL } from '~/library/config';

//utils
import statuses from '~/utils/normalStatuses';
import { shortDateFormat, timeFormat, totalTimeFormat } from '~/utils/dateFormat';
import customerFeature from '~/utils/customerFeature';
import { statusMap } from '~/utils/normalStatuses';
import { getIntegrationIconWithStatus } from '~/utils/integrationUtils';
import { getTimeBankTotalsFromData, getTimebankNormalHours } from '../../../utils/commonMethods.js';

//assets
import Edit from '../../../assets/img/editing.svg';
import Delete from '../../../assets/img/deleting.svg';
import CloseModalIcon from '../../../assets/img/CloseApproveModalIcon.svg';

const renderOvertimeSymbol = (data, t, allow_company_shifts) => {
    if (!allow_company_shifts || !data || (!data.overtimes && !data.weekly_overtimes)) return null;
    const hasBoth = data.overtimes && data.weekly_overtimes;
    const hasDaily = data.overtimes && !data.weekly_overtimes;
    const color = hasBoth ? '#ee7c19' : hasDaily ? '#447df7' : 'red';
    const label = hasBoth ? t('Daily & Weekly Overtime') : hasDaily ? t('Daily Overtime') : t('Weekly Overtime');

    return (
        <OverlayTrigger
            trigger={['hover', 'focus']}
            placement="top"
            overlay={
                <Tooltip id="overtime-type-tooltip">
                    {label}
                </Tooltip>
            }
        >
            <span className="cursor-pointer">
                <i className="fa fa-circle" style={{ color: color, fontSize: '8px' }} />
            </span>
        </OverlayTrigger>
    );
};

class TimelogsList extends Component {
    constructor(props) {
        super(props)
        const { page: _page, lastInteractedId } = this.props?.router?.location?.state || {};
        const page = _page || 0;
        if (lastInteractedId) {
            this.props.timelogStore.setLastInteractedId(lastInteractedId);
        }
        this.state = {
            accepting: null,
            acceptanceChanged: false,
            selected: null,
            isUserUploadedImg: false,
            userImageAttachmentId: null,
            isTipModal: false,
            tipAmount: '',
            isLoading: true,
            isPageAddedOrEdited: page ? true : false,
            page: page ? page : 0,
            showPreviousTimelogsModal: false,
            showMultiTaskModal: false,
            showMultiTaskModalAccept: false,
            selectedUserId: null,
            selectedForDate: null,
            showConflictsModal: {
                showModal: false,
                conflicts: null
            },
            showEditTimeModal: false,
            editTimelogId: null,
            editTimelogData: null,
            multiTaskReloadKey: 0,
            multiTaskParentId: null,
            modalInitialTab: null,
            userPromptModal: {
                source: '',
                header: '',
                showModal: false,
                sourceInfo: {},
                actionMethods: {}
            }
        }
        this.renderExpandedContent = this.renderExpandedContent.bind();
        this.rowHasAnomaly = this.rowHasAnomaly.bind();
        this.handleExpandAllSubRows = this.handleExpandAllSubRows.bind();
        this.goBack = this.goBack.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
    };

    componentWillUnmount() {
        this.props.timelogStore.clearLastInteractedId();
    }

    //this method is replacing the URL pushing part while add/edit//
    goBack = (page = 0) => {
        this.setState({ page, isPageAddedOrEdited: true });
    }

    //method to maintain react-table page in parent component//
    handlePageChange = (page, isEdit) => {
        this.setState({ page: page, isPageAddedOrEdited: isEdit });
    }

    handleOpenPreviousTimelogsModal = () => {
        this.setState({ showPreviousTimelogsModal: true });
    };

    handleResetTimebankAndProceed = async (convertedOvertimeTimelog, onAfterReset) => {
        const { commonStore, t, timelogStore } = this.props;
        await timelogStore.deleteTimebankAllByDate({ user_id: convertedOvertimeTimelog.user_id, for_date: convertedOvertimeTimelog.for_date })
            .then(res2 => {
                commonStore.addNotification(`${t(res2.message)}`, null, 'success');
                this.handleCloseUserPromptModal();
                if (onAfterReset) return onAfterReset();
            });
    }

    handleTimeBankConflictOnDelete = (convertedOvertimeConflictPrompt, onAfterReset) => {
        const { commonStore, t } = this.props;
        const { convertedOvertimeTimelog } = convertedOvertimeConflictPrompt.sourceInfo.convertedOvertimeConflict;
        if (!convertedOvertimeTimelog?.user_id || !convertedOvertimeTimelog?.for_date) {
            return commonStore.addNotification(t('No associated timebank entry found'), null, 'warning');
        }
        this.setState({
            userPromptModal: {
                ...convertedOvertimeConflictPrompt,
                actionMethods: {
                    handleCloseUserPromptModal: this.handleCloseUserPromptModal,
                    handleResetTimebankAndProceed: () => this.handleResetTimebankAndProceed(convertedOvertimeTimelog, onAfterReset)
                }
            }
        });
    };

    handleResetApprovedWeeklyOvertime = async (approvedTimesheets) => {
        const { timelogStore, commonStore, t } = this.props;
        this.setState({ isLoading: true });
        try {
            await timelogStore.resetApprovedWeeklyOvertimeTimesheets(approvedTimesheets);
            this.handleCloseUserPromptModal();
            commonStore.addNotification(t('Approved timesheets have been reset successfully.'), null, 'success');
            this.handlePageChange(this.state.page, true);
            timelogStore.resetLastListLoadTime(new Date());
        } catch (err) {
            console.error(err);
        }
        finally {
            this.setState({ isLoading: false })
        }
    };

    handleTableButtonAction = (full, type) => {
        const { id, user_id, for_date } = full;
        const mainListId = this.state.showMultiTaskModal ? (this.state.multiTaskParentId || id) : id;
        this.props.timelogStore.setLastInteractedId(mainListId);
        if (type === 'edit') {
            this.props.router.navigate(`/admin/timelogs/${id}`, { state: { timelogs: id, page: this.state.page, lastInteractedId: mainListId } });
        }
        if (type === 'remove') {
            return this.props.handleDelete(id, (id) => {
                const afterDelete = (res) => {
                    this.handlePageChange(this.state.page, true);
                    this.props.timelogStore.resetLastListLoadTime(new Date());
                    if (this.props.timelogStore.currentMultiTaskTimeLogs.length > 2) {
                        this.setState((prev) => ({
                            selectedUserId: user_id,
                            selectedForDate: for_date,
                            multiTaskReloadKey: prev.multiTaskReloadKey + 1,
                        }));
                    } else {
                        this.handleCloseMultiTaskModal();
                    }
                    return res;
                };
                return this.props.timelogStore.remove(id).then((res) => {
                    const convertedOvertimeConflict = res?.userPrompts?.find(p => p.source === 'convertedOvertimeConflict');
                    if (convertedOvertimeConflict?.showModal) {
                        return this.handleTimeBankConflictOnDelete(convertedOvertimeConflict, () => this.props.timelogStore.remove(id).then(afterDelete));
                    }
                    return afterDelete(res);
                }).catch((err) => {
                    const approvedWeeklyOvertime = err?.response?.body?.userPrompts?.find(p => p.source === 'approvedWeeklyOvertime');
                    if (!approvedWeeklyOvertime?.showModal) throw err;
                    this.setState({
                        userPromptModal: {
                            ...approvedWeeklyOvertime,
                            actionMethods: {
                                handleCloseUserPromptModal: this.handleCloseUserPromptModal,
                                handleResetApprovedWeeklyOvertime: () => this.handleResetApprovedWeeklyOvertime(approvedWeeklyOvertime.sourceInfo.approvedWeeklyOvertime.approvedTimesheets)
                            }
                        }
                    });
                });
            });
        }
    };

    alreadyProcessedCols = false;

    cols = [
        {
            Header: 'Project',
            id: 'project_name',
            accessor: ({ is_holiday, project_name, project_number, has_multiple_projects }) => (
                <span>{has_multiple_projects ? this.props.t('Multiple') : is_holiday ? this.props.t('holiday') : `${project_number || ''} | ${project_name || ''}`}</span>
            ),
            maxWidth: 95,
            minWidth: 80,
            isSortable: !this.props.commonStore?.config?.client?.data?.basicRules?.allowMutiTaskTimesheets,
            textAlign: 'start'
        },
        {
            Header: 'Task',
            id: 'tasks.name',
            accessor: ({ is_holiday, task_name, task_number, has_multiple_tasks }) => (
                <span>{has_multiple_tasks ? this.props.t('Multiple') : is_holiday ? this.props.t('holiday') : `${task_number || ''} | ${task_name || ''}`}</span>
            ),
            maxWidth: 95,
            minWidth: 80,
            isSortable: !this.props.commonStore?.config?.client?.data?.basicRules?.allowMutiTaskTimesheets,
            textAlign: 'start'
        },
        {
            Header: 'Actions',
            id: 'actions',
            sortable: false,
            accessor: (full) => this.renderTableActionButtons(full.id, full),
            maxWidth: 210,
            minWidth: 200,
        },
    ];

    getOvertime = (data, dateTimeRules, ismultitasklog, total_hours_overtime, _total_hours_overtime) => {
        const { t, commonStore } = this.props;
        return (
            <>
                <OvertimeDisplay
                    data={data ? data.overtimes : null}
                    dateTimeRules={dateTimeRules}
                    config={commonStore.config}
                    _total_hours_overtime={_total_hours_overtime}
                    total_hours_overtime={total_hours_overtime}
                    ismultitasklog={ismultitasklog}
                    t={t}
                />
                <WeeklyOvertimeDisplay
                    data={data}
                    total_hours_overtime={total_hours_overtime}
                    ismultitasklog={ismultitasklog}
                    dateTimeRules={dateTimeRules}
                    t={t}
                />
            </>
        )
    }

    componentDidMount() {
        const { commonStore, userStore, t } = this.props;
        const dateTimeRules = commonStore.getDateTimeRules();
        const { allow_company_shifts = false, data = {} } = commonStore?.config?.client;
        const { basicRules = null, loginRules = null } = data
        const overtimeAutomaticMode = basicRules?.overtimeAutomaticMode || false
        const showAnomalies = loginRules?.trackAnomalies || false;
        const allowTimeBank = basicRules?.timeBankSettings?.allowTimeBank || false;
        const allowMutiTaskTimesheets = commonStore?.config?.client?.data?.basicRules?.allowMutiTaskTimesheets;
        const allowAutomaticFlexitimeTimeBank = commonStore?.config?.client?.data?.basicRules?.timeBankSettings?.allowAutomaticFlexitimeTimeBank;
        this.cols.splice(
            this.cols.length - 1,
            0,
            {
                Header: 'Date',
                id: 'for_date',
                accessor: ({ for_date, from, to, status, data }) => <span className='timelog-date'>
                    {from > to && status !== 'draft' ?
                        `${for_date && shortDateFormat(for_date, dateTimeRules)} | ${shortDateFormat(moment(for_date).add(1, 'days'), dateTimeRules)}`
                        : `${for_date && shortDateFormat(for_date, dateTimeRules)}`}
                    {renderOvertimeSymbol(data, t, allow_company_shifts)}
                </span>,
                maxWidth: 75,
                minWidth: 75,
            },
            {
                Header: 'Time',
                id: 'from',
                accessor: ({ id, project_id, task_id, distance_type, from, to, break: breakTime, for_date, status, anomaly, data, user_id, is_manually_managed, ismultitasklog, shift, gps_data, tracker_status }) => {
                    const isManualOvertime = !(basicRules?.overtimeAutomaticMode || allow_company_shifts) && data?.overtimes && Object.values(data?.overtimes).length > 0
                    const isSystemEntry = (gps_data && gps_data.systemEntry) ? gps_data.systemEntry : false;
                    const disableQuickTimesheetEdit = isSystemEntry || status !== 'active';

                    return <div>
                        <OverlayTrigger
                            trigger={['hover', 'focus']}
                            placement="top"
                            overlay={
                                <Tooltip id={`shift-tooltip-${id}`}>
                                    {!!shift?.id ? (
                                        <div style={{ textAlign: 'left' }}>
                                            <div><strong>{t('Shift')}</strong></div>
                                            <div>{t('Start Time')}: {timeFormat(shift.start_time, dateTimeRules)}</div>
                                            <div>{t('End Time')}: {timeFormat(shift.end_time, dateTimeRules)}</div>
                                        </div>
                                    ) : (
                                        <div>{t('No shift found')}</div>
                                    )}
                                </Tooltip>
                            }
                        >
                            <span className="cursor-pointer me-1">
                                <i className={`fa fa-clock-o ${shift?.id ? 'text-info' : 'text-muted'}`} />
                            </span>
                        </OverlayTrigger>
                        <OverlayTrigger
                            trigger={['hover', 'focus']}
                            placement="top"
                            overlay={
                                <Tooltip id={`edit-time-tooltip-${id}`}>
                                    {isSystemEntry
                                        ? t('Cannot edit time as its system entry')
                                        : status === 'approved'
                                            ? t('Cannot edit time as its approved')
                                            : status === 'rejected'
                                                ? t('Cannot edit time as its rejected')
                                                : status === 'draft'
                                                    ? t('Cannot edit started timesheet')
                                                    : t('Edit Time')}
                                </Tooltip>
                            }
                        >
                            <span className={!disableQuickTimesheetEdit ? 'cursor-pointer custom-theme-blue-color fw-bold' : 'fw-bold'}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    if (disableQuickTimesheetEdit) return;
                                    ismultitasklog ? this.handleOpenMultiTaskModal(user_id, for_date, id)
                                        : this.handleShowEditTimeModal({ id, user_id, project_id, task_id, distance_type, from, to, for_date, breakTime, data, is_manually_managed, isManualOvertime, gps_data, tracker_status })
                                }}>
                                {showAnomalies && this.rowHasAnomaly({ anomaly }) && !data.toChangedById && <i className='fa fa-exclamation text-danger' />}
                                {timeFormat(from, dateTimeRules)} - {status === 'draft' ? '...' : timeFormat(to, dateTimeRules)}
                                {(status !== 'draft' && !!data?.fromChangedById && data.previousFrom && data.previousTo) &&
                                    <p className='text-danger font-size-10 fw-bold p-0 m-0' >
                                        {timeFormat(data.previousFrom, dateTimeRules)} -  {timeFormat(data.previousTo, dateTimeRules)}
                                    </p>
                                }
                            </span>
                        </OverlayTrigger>
                    </div>
                },
                maxWidth: 110,
                minWidth: 110,
            }
        );

        this.cols.splice(this.cols.length - 1, 0, {
            Header: (
                <OverlayTrigger
                    trigger={['hover', 'focus']}
                    placement="top"
                    overlay={
                        <Tooltip id="gps-type-tooltip">
                            <div className="d-flex flex-column justify-content-start align-items-start">
                                <span className='fw-600 fs-14'><i className="pe-7s-map-marker fs14 fw-600 color-2550AC" /> - {t('GPS')}</span>
                                <div className='d-flex align-items-center fs-14'><i className="pe-7s-power text-danger fs14 fw-600" /> - {t('Auto logout')}</div>
                                <span className='fw-600 ms-1 fs-14'><i className="fas fa-mobile-alt fs15" /> - {t('Mobile')}</span>
                                <span className='fw-600 ms-1 fs-14'><i className="pe-7s-monitor text-dark fw-600" /> - {t('Web')}/{t('System')}</span>
                                <div>
                                    <i className="pe-7s-map-marker fs14 fw-600 color-2550AC" />
                                    <div className="position-absolute fs-14" style={{ top: '84%', left: '6%', width: '11%', height: '2px', background: '#FF1E50', transform: 'rotate(-45deg)', marginTop: '-1px' }} />
                                    - {t('No location')}
                                </div>
                            </div>
                        </Tooltip>
                    }
                >
                    <span className="cursor-pointer fw-600">{t('Type')}</span>
                </OverlayTrigger>
            ),
            id: 'gps_data',
            sortable: false,
            accessor: (row) => <GPSInfo status={row.status} data={row.gps_data} full={row} onlyIcon />,
            maxWidth: 50,
            minWidth: 40,
        });
        this.cols.splice(
            this.cols.length - 1,
            0,
            {
                Header: 'Total',
                title: t('Total Hours'),
                id: 'total_hours_normal',
                accessor: ({ total_hours_normal, total_hours_overtime, data, data_array, status }) => {
                    const new_data_array = allowMutiTaskTimesheets ? data_array : [data];
                    const { totalNormalMinsAll } = allowTimeBank && new_data_array?.length ? getTimebankNormalHours(new_data_array) : 0;
                    const timeBankTotal = allowTimeBank && new_data_array?.length ? getTimeBankTotalsFromData(new_data_array) : 0;
                    const total = (status !== 'approved' ? (Number(timeBankTotal) || 0) : Math.max(0, Number(timeBankTotal) || 0)) + (status !== 'approved' ? (Number(total_hours_normal) || 0) - (Number(totalNormalMinsAll) || 0) : (Number(total_hours_normal) || 0)) + (Number(total_hours_overtime) || 0);
                    return (
                        <div>{totalTimeFormat(total, dateTimeRules) || '-'}</div>
                    )
                },
                maxWidth: allowTimeBank ? 50 : 70,
                minWidth: allowTimeBank ? 30 : 60
            },
            allowTimeBank ?
                (
                    {
                        Header: 'OT | TB',
                        id: 'total_hours_overtime',
                        title: `${t('Overtime')} ${t('and')} ${t('Timebank')}`,
                        accessor: ({ data, _total_hours_overtime, total_hours_overtime, ismultitasklog, data_array, is_manually_managed, isOvertimeCommentMissing }) => {
                            const new_data_array = allowMutiTaskTimesheets ? data_array : [data];
                            const timeBankTotal = allowTimeBank && new_data_array?.length ? getTimeBankTotalsFromData(new_data_array) : null;
                            if (allowTimeBank) {
                                return (
                                    <div className='d-flex justify-content-center align-items-center'>
                                        {isOvertimeCommentMissing &&
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    <Tooltip id="tooltip-top">
                                                        {t('Comment for overtime is missing')}
                                                    </Tooltip>
                                                }
                                            >
                                                <i className="fa fa-exclamation-triangle text-warning" aria-hidden="true"></i>
                                            </OverlayTrigger>
                                        }
                                        {is_manually_managed &&
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    <Tooltip id="tooltip-top">
                                                        {allowAutomaticFlexitimeTimeBank ? t("Mandatory overtime/flexitime") : t("Mandatory overtime")}
                                                    </Tooltip>
                                                }
                                            >
                                                <i className="fa fa-info-circle text-info" aria-hidden="true"></i>
                                            </OverlayTrigger>
                                        }
                                        {(data.overtimes || is_manually_managed || total_hours_overtime) ?
                                            !ismultitasklog ?
                                                <OverlayTrigger
                                                    key="timesheet_status"
                                                    placement="top"
                                                    overlay={
                                                        <Tooltip id="tooltip-top">
                                                            {this.getOvertime(data, dateTimeRules, ismultitasklog, total_hours_overtime, _total_hours_overtime)}
                                                        </Tooltip>
                                                    }
                                                >
                                                    <div className='text-center' style={{ fontSize: '10px', lineHeight: '10px', }}>
                                                        {total_hours_overtime ? totalTimeFormat(total_hours_overtime, dateTimeRules) : <span>-</span>}
                                                    </div>
                                                </OverlayTrigger>
                                                :
                                                this.getOvertime(data, dateTimeRules, ismultitasklog, total_hours_overtime, _total_hours_overtime)
                                            :
                                            overtimeAutomaticMode && !allow_company_shifts ?
                                                this.getOvertime(data, dateTimeRules, ismultitasklog, total_hours_overtime, _total_hours_overtime)
                                                : '-'
                                        }
                                        &nbsp;|&nbsp;
                                        <div className='text-center' style={{ fontSize: '10px', lineHeight: '10px', }}>
                                            {timeBankTotal ? totalTimeFormat(timeBankTotal, dateTimeRules) : '-'}
                                        </div>
                                    </div>
                                )
                            }
                        },
                        maxWidth: 100,
                        minWidth: 100,
                    }
                )
                :
                (
                    {
                        Header: 'Overtime',
                        id: 'total_hours_overtime',
                        title: t('Overtime and Timebank hours'),
                        accessor: ({ data, dateTimeRules, _total_hours_overtime, total_hours_overtime, ismultitasklog, is_manually_managed, isOvertimeCommentMissing }) => (
                            <div className="d-flex justify-content-center align-items-center">
                                <div>
                                    {isOvertimeCommentMissing &&
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip id="tooltip-top">
                                                    {t('Comment for overtime is missing')}
                                                </Tooltip>
                                            }
                                        >
                                            <i className="fa fa-exclamation-triangle text-warning me-1" aria-hidden="true"></i>
                                        </OverlayTrigger>
                                    }
                                    {is_manually_managed &&
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip id="tooltip-top">
                                                    {allowAutomaticFlexitimeTimeBank ? t("Mandatory overtime/flexitime") : t("Mandatory overtime")}
                                                </Tooltip>
                                            }
                                        >
                                            <i className="fa fa-info-circle text-info me-1" aria-hidden="true"></i>
                                        </OverlayTrigger>
                                    }
                                </div>
                                <div className='d-flex justify-content-center align-items-center flex-column'>
                                    <>
                                        <OvertimeDisplay
                                            data={data ? data.overtimes : null}
                                            dateTimeRules={dateTimeRules}
                                            config={commonStore.config}
                                            _total_hours_overtime={_total_hours_overtime}
                                            total_hours_overtime={total_hours_overtime}
                                            ismultitasklog={ismultitasklog}
                                            t={t}
                                        />
                                        <WeeklyOvertimeDisplay
                                            data={data}
                                            total_hours_overtime={total_hours_overtime}
                                            ismultitasklog={ismultitasklog}
                                            dateTimeRules={dateTimeRules}
                                            t={t}
                                        />
                                    </>
                                </div>
                            </div>
                        ),
                        maxWidth: 80,
                        minWidth: 80,
                    }
                )
            ,
            {
                Header: 'REG',
                id: 'total_net_hours',
                title: t('Regular Hours'),
                accessor: ({ total_hours_normal, data_array, status }) => <span>
                    {totalTimeFormat(status === 'approved' ? total_hours_normal :
                        total_hours_normal - (data_array?.length ? getTimebankNormalHours(data_array).totalNormalMinsPositive : 0), dateTimeRules)}</span>,
                maxWidth: 50,
                minWidth: 50,
            },
        );
        if (!this.alreadyProcessedCols) {
            if (userStore.currentUser.user_type !== 'member') {
                this.cols.splice(0, 0, {
                    Header: 'Member',
                    id: 'users.first_name',
                    accessor: ({ first_name, last_name }) => <span>{first_name + ' ' + last_name}</span>,
                    maxWidth: 120,
                    minWidth: 80,
                    isSortable: true,
                    textAlign: 'start',
                });
            }
            this.alreadyProcessedCols = true;
        }
        this.filterByRedirection();
    }

    handleShowEditTimeModal = (timelog) => {
        const mainListId = this.state.showMultiTaskModal ? (this.state.multiTaskParentId || timelog.id) : timelog.id;
        this.props.timelogStore.setLastInteractedId(mainListId);
        this.setState({ showEditTimeModal: true, editTimelogId: timelog.id, editTimelogData: { ...timelog, break: timelog.breakTime } });
    }

    handleCloseEditTimeModal = () => {
        this.setState({ showEditTimeModal: false, editTimelogId: null, editTimelogData: null });
    }

    filterByRedirection = () => {
        const dashboardRedirected = this.props.router.location?.state?.dashboardRedirected
        if (!dashboardRedirected) return this.setState({ isLoading: false })
        if (dashboardRedirected === 'active') {
            this.props.timelogStore.setFilter("fromDate", `${moment(new Date()).add(-1, 'days').format('YYYY-MM-DD')}`) // yesterday
            this.props.timelogStore.setFilter("toDate", `${moment(new Date()).format('YYYY-MM-DD')}`) //today
            this.props.timelogStore.setFilter("fromDate1", new Date(moment(new Date()).add(-1, 'days').format('YYYY-MM-DD')))
            this.props.timelogStore.setFilter("toDate1", new Date())
        }
        this.props.timelogStore.setFilter("status", `${dashboardRedirected}`)
        this.props.timelogStore.onFilter()
        this.setState({ isLoading: false })
    }

    handleAccept(id, full, fromSyncHistory = false) {
        this.props.timelogStore.setLastInteractedId(id);
        this.setState({
            accepting: {
                ids: [id],
                count: 1,
                entity: 'timelog',
                startedByWorklogButton: true,
            },
            modalInitialTab: fromSyncHistory ? 'payrollHistory' : null
        });
    }

    handleClosePastTimelogModal = () => {
        this.setState({ showPreviousTimelogsModal: false });
    };

    onSelectionChanged(ids) {
        this.setState({ selected: ids });
    }

    onMassAccept() {
        const ids = [];
        const { timelogStore, commonStore, t } = this.props;
        const { currentList } = timelogStore;
        if (!this.state.selected || (this.state.selected && !Object.values(this.state.selected).filter(Boolean).length > 0)) {
            commonStore.addNotification(t('Oops! You need to select hours from the timesheet before approving in bulk.'), null, 'error');
            return;
        }
        Object.keys(this.state.selected).forEach((id) => {
            if (this.state.selected[id]) ids.push(id);
        });
        const selectedItems = ids.map(id => currentList.rows.find(item => item.id === Number(id)));
        const allSameStatus = selectedItems.every(item => item.status === selectedItems[0].status);

        if (!allSameStatus) {
            commonStore.addNotification(t('Please select records with the same status to proceed with this action.'), null, 'warning');
            return;
        }

        this.setState({
            acceptanceChanged: false,
            accepting: {
                ids,
                count: ids.length,
                entity: 'timelog',
            },
        });
    }

    afterMassAccept() {
        this.handlePageChange(this.state.page, true);
        this.props.timelogStore.resetLastListLoadTime(new Date());
        this.setState({ accepting: null, acceptanceChanged: true });
    }

    handleOpenMultiTaskModal = async (userId, forDate, id) => {
        this.props.timelogStore.setLastInteractedId(id);
        this.setState((prev) => ({
            showMultiTaskModal: true,
            selectedUserId: userId,
            selectedForDate: forDate,
            multiTaskReloadKey: prev.multiTaskReloadKey + 1,
            multiTaskParentId: id || null,
        }));
    }

    handleMultiTaskModalAccept = async (userId, forDate, id, fromSyncHistory = false) => {
        this.props.timelogStore.setLastInteractedId(id);
        this.setState({
            showMultiTaskModalAccept: true,
            selectedUserId: userId,
            selectedForDate: forDate,
            modalInitialTab: fromSyncHistory ? 'payrollHistory' : null
        })
    }

    handleMismatchStatus = (full) => {
        const { t, commonStore } = this.props;
        this.setState({
            showMultiTaskModalAccept: true, selectedUserId: full.user_id, selectedForDate: full.for_date
        }, () => {
            commonStore.addNotification(t('Please reset all timelogs before making other changes.'), null, 'warning');
        });
    }

    handleCloseUserPromptModal = () => {
        this.setState({ userPromptModal: { ...this.state.userPromptModal, showModal: false } })
    }

    showApproveRejectCommentModal = (full) => {
        const { commonStore } = this.props;
        const dateTimeRules = commonStore.getDateTimeRules();
        this.setState({
            userPromptModal: {
                source: 'adminPmComment',
                header: 'Comment',
                showModal: true,
                sourceInfo: {
                    status: full.status,
                    status_note: full.status_note,
                    status_changed_by: commonStore.getUsername(full.status_changed_by),
                    status_changed_on: shortDateFormat(full.status_changed_on, dateTimeRules)
                },
                actionMethods: { handleCloseUserPromptModal: this.handleCloseUserPromptModal }
            }
        });
    }

    renderTableActionButtons = (id, full) => {
        const { t, commonStore, timelogStore } = this.props;
        const { config } = commonStore;
        const allowTimeBank = config.client.data.basicRules?.timeBankSettings?.allowTimeBank;
        const { user_type, id: userId } = this.props.userStore.currentUser;
        const { currentMultiTaskTimeLogs } = timelogStore;
        const dateTimeRules = commonStore.getDateTimeRules();
        const showStatusBlock = customerFeature('allow_accepting');
        const hideEditWhenAccepted = customerFeature('timelog_no_edit_for_approved');
        const hideEditWhenNotDraft = customerFeature('timelog_no_edit_for_done');
        let hideEdit = hideEditWhenAccepted && full.status === 'approved' && user_type === 'member';
        if (hideEditWhenNotDraft && full.status !== 'draft' && user_type === 'member') {
            hideEdit = true;
        }
        const showStatus = (user_type === 'pm' || user_type === 'admin') && customerFeature('allow_accepting');
        const allow = (user_type === 'pm' || user_type === 'admin') && customerFeature('pm_allow_editing_all');
        const showCommentModal = user_type === 'member' && (full.status === 'approved' || full.status === 'rejected')

        let statusText = full.status;
        if (!statusText) statusText = 'active';
        statusText = statusMap[statusText] || '';
        const actionable = showStatus && full.status !== 'approved';

        const isStatusMismatched = this.state.showMultiTaskModal && currentMultiTaskTimeLogs && currentMultiTaskTimeLogs.length > 0 && !currentMultiTaskTimeLogs.every(log => log.status === currentMultiTaskTimeLogs[0].status) && !currentMultiTaskTimeLogs.some(log => log.status === 'draft');
        const multiTaskConflictedTimelog = this.state.showMultiTaskModal ? currentMultiTaskTimeLogs?.find(t => t.has_conflicts) : null;
        return (
            <div className="actions-center">
                {
                    config?.integration_details?.product && full.status === 'approved' && (!full.int_id) && user_type !== 'member' && (<OverlayTrigger
                        placement="top"
                        key="payroll_history"
                        overlay={
                            <Tooltip>{`${t("View")} ${t("Payroll")} ${t("History")}`}</Tooltip>
                        }
                    >
                        <button
                            type="button"
                            className="p-0 ml-2 bg-transparent border-0"
                            title={`${t("View")} ${t("Payroll")} ${t("History")}`}
                            onClick={() => full.ismultitasklog ? this.handleMultiTaskModalAccept(full.user_id, full.for_date, full.id, true) : this.handleAccept(id, full, true)}
                        >
                            <i className="fa fa-history" style={{ color: '#888', fontSize: '1.5em' }} />
                        </button>
                    </OverlayTrigger>)
                }
                {getIntegrationIconWithStatus(config, full, t, allowTimeBank)}
                {full.has_conflicts && (
                    <div>
                        <OverlayTrigger key="reset-btn" placement='top'
                            overlay={<Tooltip id='tooltip-conflicts'>
                                {t('Conflicts')}
                            </Tooltip>}
                        >
                            <Button icon_sm fill
                                onClick={() => this.handleShowConflict(full)}>
                                {<i className="fa fa-exclamation text-danger"></i>}
                            </Button>
                        </OverlayTrigger>
                    </div>
                )}
                {full.status !== 'draft' && showStatusBlock && (
                    <OverlayTrigger
                        key="timesheet_status"
                        placement="top"
                        overlay={
                            <Tooltip id="tooltip-top">
                                {
                                    full.ismultitasklog && full.has_mismatched_status ? (
                                        t('Please reset all timelogs before making other changes.')
                                    )
                                        :
                                        ([t(statusText)].map((text) => (
                                            <>
                                                {text}
                                                <br />
                                            </>
                                        )))}
                            </Tooltip>
                        }
                    >
                        <div
                            className={`status-block ${full.ismultitasklog && full.has_mismatched_status ? 'status-mismatch' : `status-${full.status || 'active'}`}${actionable ? ' status-actionable' : ''
                                }${user_type === 'member' ? ' status-no-click-for-member' : ''}`}
                            onClick={() => (showCommentModal ? this.showApproveRejectCommentModal(full) : !full?.removestatus && showStatus ? full.has_conflicts ? this.handleShowConflict(full) : full.ismultitasklog ? this.handleMultiTaskModalAccept(full.user_id, full.for_date, full.id) : this.handleAccept(id, full) : null)}                        >
                            {full.has_mismatched_status && full.ismultitasklog ? (
                                <div>{t('Reset')}</div>
                            ) :
                                (statusText.toLowerCase() === 'pending' || !(full.status_changed_by && full.status_changed_on) ? (
                                    <>
                                        <div>{t(statusText)}</div>
                                        <div className="text-capitalize timelogs-text-shrading">
                                            {full?.status_note ? full.status_note : ''}
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className="text-capitalize">
                                            {full.status_changed_by && shortDateFormat(full.status_changed_on, dateTimeRules)}
                                        </div>
                                        <div className="text-capitalize timelogs-text-shrading">
                                            {this.props.commonStore.getUsername(full.status_changed_by)}
                                        </div>
                                    </>
                                ))}
                        </div>
                    </OverlayTrigger>
                )}
                {full.user_image_attachment_id && (
                    <OverlayTrigger
                        key="user-uploded-img"
                        placement="top"
                        overlay={<Tooltip id="tooltip-top">{t('User Uploaded Image')}</Tooltip>}
                    >
                        <Button
                            icon_sm
                            fill
                            onClick={() =>
                                this.setState({
                                    userImageAttachmentId: full.user_image_attachment_id,
                                    isUserUploadedImg: true,
                                })
                            }
                            simple
                            icon
                        >
                            <i className="fa fa-user" />
                        </Button>
                    </OverlayTrigger>
                )}
                {full.status === 'draft' && (
                    <div className={`text-dark status-block status-${full.status || 'active'}`}>{t(statusText)}</div>
                )}
                {!hideEdit &&
                    <OverlayTrigger
                        key="timelog_edit"
                        placement="top"
                        overlay={
                            <Tooltip id="tooltip-top">
                                {t('Edit Timesheet')}
                            </Tooltip>
                        }
                    >
                        <Button icon_sm fill
                            onClick={() => !full.ismultitasklog && full.has_conflicts
                                ? this.handleShowConflict(full)
                                : multiTaskConflictedTimelog && !full.ismultitasklog && full.status !== 'draft'
                                    ? this.handleShowConflict(multiTaskConflictedTimelog)
                                    : isStatusMismatched && user_type !== 'member'
                                        ? this.handleMismatchStatus(full)
                                        : (full.ismultitasklog ? this.handleOpenMultiTaskModal(full.user_id, full.for_date, id) : this.handleTableButtonAction(full, 'edit'))}>
                            {(userId !== full.user_id && !allow) || full.ismultitasklog ? <i className="fa fa-eye" /> : <img src={Edit} alt={'edit'} />}
                        </Button>
                    </OverlayTrigger>
                }
                {(userId === full.user_id || allow) && (
                    <OverlayTrigger
                        key="timelog_delete"
                        placement="top"
                        overlay={
                            <Tooltip id="tooltip-top">
                                {full.status === 'approved' && config.integration_details.product ?
                                    t('Please reset approved hours before deleting them permanently from Time & Control')
                                    : t('Delete Timesheet')
                                }.
                            </Tooltip>
                        }
                    >
                        <Button
                            icon_sm_delete
                            fill
                            onClick={() => !full.ismultitasklog && full.has_conflicts
                                ? this.handleShowConflict(full) : multiTaskConflictedTimelog && !full.ismultitasklog && full.status !== 'draft'
                                    ? this.handleShowConflict(multiTaskConflictedTimelog) : isStatusMismatched && user_type !== 'member'
                                        ? this.handleMismatchStatus(full)
                                        : (full.ismultitasklog ? this.handleOpenMultiTaskModal(full.user_id, full.for_date, id) : this.handleTableButtonAction(full, 'remove'))}
                            disabled={(full.status === 'approved' && config.integration_details.product)}
                        >
                            <img src={Delete} alt="delete" />
                        </Button>
                    </OverlayTrigger>
                )}
            </div>
        );
    };

    rowHasAnomaly(row) {
        const { anomaly, data } = row;
        return !data?.toChangedById && (anomaly?.start?.is_early || anomaly?.start?.is_late || anomaly?.start?.is_offsite || anomaly?.end?.is_early || anomaly?.end?.is_late || anomaly?.end?.is_offsite);
    }

    renderExpandedContent = (row) => {
        const { t } = this.props;
        const { status, anomaly } = row;
        return (
            <Row className='gx-0'>
                <Col xs={status !== 'draft' ? 3 : 6} md={status !== 'draft' ? 2 : 4} className={status !== 'draft' ? '' : 'd-flex'}>
                    <div className='d-flex'>
                        <div>{t('Clock In')}:&nbsp;</div>
                        <div className={anomaly?.start?.is_early ? "text-warning" : anomaly?.start?.is_late ? "text-danger" : "text-success"}>
                            <i className='fa fa-clock-o' />
                            {anomaly?.start?.is_early ? t('Early') : anomaly?.start?.is_late ? t('Late') : t('On-time')}
                        </div>
                    </div>
                    <div className={status !== 'draft' ? 'd-flex' : 'ms-5 d-flex'}>
                        <div>{t('Location')}:&nbsp;</div>
                        <div className={anomaly?.start?.is_offsite ? "text-danger" : "text-success"}>
                            <i className='fa fa-map-marker' />
                            {anomaly?.start?.is_offsite ? t('Off-site') : t('On-site')}
                        </div>
                    </div>
                </Col>
                <Col xs={status !== 'draft' ? 3 : 6} md={status !== 'draft' ? 4 : 8}>
                    <div className='d-flex'>
                        <div className=''>{t('Comment')}:&nbsp;</div>
                        <div className='text-info'>{t(anomaly?.start?.comment)}</div>
                    </div>
                </Col>
                {status !== 'draft' &&
                    <>
                        <Col xs={3} md={2}>
                            <div className='d-flex'>
                                <div>{t('Clock Out')}:&nbsp;</div>
                                <div className={anomaly?.end?.is_early ? "text-warning" : anomaly?.end?.is_late ? "text-danger" : "text-success"}>
                                    <i className='fa fa-clock-o' />
                                    {anomaly?.end?.is_early ? t('Early') : anomaly?.end?.is_late ? t('Late') : t('On-time')}
                                </div>
                            </div>
                            <div className='d-flex'>
                                <div>{t('Location')}:&nbsp;</div>
                                <div className={anomaly?.end?.is_offsite ? "text-danger" : "text-success"}>
                                    <i className='fa fa-map-marker' />
                                    {anomaly?.end?.is_offsite ? t('Off-site') : t('On-site')}
                                </div>
                            </div>
                        </Col>
                        <Col xs={3} md={4}>
                            <div className='d-flex'>
                                <div >{`${t('Comment')}`}:&nbsp;</div>
                                <div className='text-info'>{t(anomaly?.end?.comment)}</div>
                            </div>
                        </Col>
                    </>
                }
            </Row >
        )
    }

    handleExpandAllSubRows = (is_clicked) => {
        if (is_clicked === this.props.timelogStore.filters?.showAnomalies) return;
        this.props.timelogStore.setFilter("showAnomalies", is_clicked)
        this.props.timelogStore.onFilter()
    }

    resetAllLogs = async () => {
        const { timelogStore, commonStore, t } = this.props;
        const { config } = commonStore;
        const { currentMultiTaskTimeLogs } = this.props.timelogStore;
        const isIntegration = config?.integration_details?.product ? true : false;
        this.setState({ isLoading: true });
        try {
            const body = {
                user_id: currentMultiTaskTimeLogs[0].user_id,
                for_date: currentMultiTaskTimeLogs[0].for_date,
                syncWithIntegration: isIntegration,
                status: 'reset',
                notes: '',
                admin_note: ''
            }
            await timelogStore.multiTimelogStatus(body);
            commonStore.addNotification(t('All timelogs have been reset successfully.'), null, 'success');
            this.handleCloseMultiTaskModal();
        } catch (err) {
            console.error(err);
        }
        finally {
            this.setState({ isLoading: false })
        }
    }

    handleShowConflict = async (full, isSetLastInteractedId = true) => {
        if (isSetLastInteractedId) {
            if (full.id && !this.state.showConflictsModal?.showModal) {
                const idToHighlight = this.state.multiTaskParentId || full.id;
                this.props.timelogStore.setLastInteractedId(idToHighlight);
            }
        }
        const body = {
            user_id: full.user_id,
            for_date: full.for_date,
        }
        const conflicts = await this.props.timelogStore.getTimelogConflicts(body)
        this.setState({ showConflictsModal: { showModal: true, conflicts }, showMultiTaskModal: false })
    }

    handleCloseConflictsModal = async () => {
        const { showConflictsModal } = this.state;
        this.setState({ showConflictsModal: { showModal: false } });
        const body = {
            user_id: showConflictsModal.conflicts?.allTimelogs[0]?.user_id,
            for_date: showConflictsModal.conflicts?.allTimelogs[0]?.for_date,
        }
        await this.props.timelogStore.getTimelogConflicts(body)
        this.handlePageChange(this.state.page, true);
        this.props.timelogStore.resetLastListLoadTime(new Date());
    }

    handleCloseMultiTaskModal = () => {
        this.setState({ showMultiTaskModal: false }, () => {
            this.props.timelogStore.changeObservable('currentMultiTaskTimeLogs', []);
        });
    }

    getRowClassName = (row) => {
        const isInteracted = row.id === this.props.timelogStore.lastInteractedId;
        const classes = [
            row.has_conflicts ? 'conflicted-bg-color' : '',
            this.props.commonStore.isHoliday(row.for_date) ? 'holiday-row-bg' : '',
            isInteracted ? 'interacted-row' : '',
        ];
        return classes.filter(Boolean).join(' ');
    }

    render() {
        const { t, commonStore } = this.props
        const { loading, filters, appliedFilters, currentMultiTaskTimeLogs } = this.props.timelogStore;
        if (this.state.isLoading)
            return <LoadingSpinner />;

        const { user_type, id: userId } = this.props.userStore.currentUser;
        const { accepting, acceptanceChanged, isUserUploadedImg, userImageAttachmentId, showMultiTaskModal,
            selectedUserId, selectedForDate, showMultiTaskModalAccept, showConflictsModal, userPromptModal } = this.state;
        const { config } = commonStore;

        const { allow_company_shifts = false, data = {} } = this.props.commonStore?.config?.client;
        const showAddForm = user_type === 'member' || user_type === 'pm' || !customerFeature('pm_no_register');
        const allow = (user_type === 'pm' || user_type === 'admin') && customerFeature('pm_allow_editing_all');
        const showStatus = (user_type === 'pm' || user_type === 'admin') && customerFeature('allow_accepting');
        const showAnomalies = data?.loginRules?.trackAnomalies || false;
        const dateTimeRules = commonStore.getDateTimeRules();
        const { basicRules = null } = data
        const overtimeAutomaticMode = basicRules?.overtimeAutomaticMode || false;
        const allowTimeBank = basicRules?.timeBankSettings?.allowTimeBank || false;
        const allowAutomaticFlexitimeTimeBank = basicRules?.timeBankSettings?.allowAutomaticFlexitimeTimeBank;
        const preventPmSelfApproval = basicRules?.preventPmSelfApproval;
        const isOwnRecordUnapprovable = row => preventPmSelfApproval && user_type === 'pm' && parseInt(row.user_id) === parseInt(userId);
        const selfApprovalMessage = t('You cannot approve, reject or reset your own request');
        const isSelfBlockedMultiTask = currentMultiTaskTimeLogs?.length > 0 && isOwnRecordUnapprovable(currentMultiTaskTimeLogs[0]);

        const data_array = currentMultiTaskTimeLogs?.length ? currentMultiTaskTimeLogs.map(ele => ele.data) : [];
        const timeBankMins = data_array.length ? getTimeBankTotalsFromData(data_array) : 0
        const { totalNormalMinsAll } = data_array.length ? getTimebankNormalHours(data_array) : 0;
        const conflictedTimelog = currentMultiTaskTimeLogs?.find(t => t.has_conflicts)

        return (
            <Fragment>
                {this.state.showPreviousTimelogsModal && (
                    <PastTimelogModal onClose={this.handleClosePastTimelogModal} show={this.state.showPreviousTimelogsModal} />
                )}
                <GenericList
                    header={
                        <GenericFilter
                            filters={filters}
                            setFilter={(name, value) => this.props.timelogStore.setFilter(name, value)}
                            onFilter={() => this.props.timelogStore.onFilter()}
                            loading={loading}
                            hasSearch={user_type !== 'member'}
                            searchFilterPlaceholder={"Search by employee name"}
                            hasDateFilters={true}
                            hasProjectFilter={true}
                            hasStatusFilter={true}
                            statusOptions={statuses}
                        />
                    }
                    getRowClassName={this.getRowClassName}
                    tableHeader={this.props.t('Working hours')}
                    onRowClick={(row) => {
                        const current = this.props.timelogStore.lastInteractedId;
                        this.props.timelogStore.setLastInteractedId(current === row.id ? null : row.id);
                    }}
                    columns={this.cols}
                    onSelectionChanged={(selection) => this.onSelectionChanged(selection)}
                    allowCheckboxes={showStatus}
                    disableCheckbox={row => row.ismultitasklog || isOwnRecordUnapprovable(row)}
                    filters={appliedFilters}
                    lastListLoadTime={this.props.timelogStore.lastListLoadTime}
                    forceReload={this.props.timelogStore.deleteSuccess || acceptanceChanged}
                    onChangeStatus={() => this.onMassAccept()}
                    showStatus={showStatus}
                    loading={loading}
                    requestData={(params) => this.props.timelogStore.loadList(params)}
                    pageSize={50}
                    showSubRows={showAnomalies}
                    expandableRowHandler={"from"}
                    expandadedRowContent={this.renderExpandedContent}
                    hasSubRows={this.rowHasAnomaly}
                    handleExpandAllSubRows={this.handleExpandAllSubRows}
                    handlePageChange={(page, isEdit) => this.handlePageChange(page, isEdit)} //handles page change
                    page={this.state.page} //new page props to maintain page from parent//
                    isPageAddedOrEdited={this.state.isPageAddedOrEdited} //to load same page after edit//
                >
                    {(showAddForm || allow) && (
                        <>
                            {allow_company_shifts && (
                                <div className='d-flex flex-column me-3'>
                                    <span className='font-size-12'><i className="fa fa-circle" style={{ color: '#447df7', fontSize: '8px' }}></i>{t('Daily Overtime')}</span>
                                    <span className='font-size-12'><i className="fa fa-circle" style={{ color: 'red', fontSize: '8px' }}></i>{t('Weekly Overtime')}</span>
                                    <span className='font-size-12'><i className="fa fa-circle" style={{ color: '#ee7c19', fontSize: '8px' }}></i>{t('Daily & Weekly Overtime')}</span>
                                </div>
                            )}
                            <Button fill wd onClick={() => this.props.onAdd(this.handleOpenPreviousTimelogsModal)}>
                                <i className="fa fa-plus-circle fa-xl margin-right-10" /> {t('Add new')}
                            </Button>
                        </>
                    )}
                </GenericList>
                <Modal
                    className={`ApproveModal ${accepting?.startedByWorklogButton ? 'modal right fade modal_revised' : ''}`}
                    size="lg"
                    show={!!accepting}
                    onHide={() => this.setState({ accepting: null })}
                >
                    <Modal.Header>
                        <Modal.Title className="w-100 text-center ApproveModal__title m-0">
                            {t('Accept/reject')}
                        </Modal.Title>
                        <img
                            src={CloseModalIcon}
                            className="cursor-pointer"
                            alt='close icon'
                            onClick={() => this.setState({ accepting: null, modalInitialTab: null })}
                        />
                    </Modal.Header>

                    <Modal.Body className="pb-1 plr-50">
                        {accepting && accepting.ids.length > 0 && !accepting?.startedByWorklogButton ?
                            <AbsenceVacationMassTimelogApproval params={accepting} afterSave={() => this.afterMassAccept()} />
                            : <ModalEditor params={accepting} afterSave={() => this.afterMassAccept()} initialTab={this.state.modalInitialTab} />
                        }
                    </Modal.Body>
                </Modal>
                <Modal
                    size="sm"
                    show={isUserUploadedImg}
                    onHide={() => this.setState({ isUserUploadedImg: false, userImageAttachmentId: null })}
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{t('User Uploaded Image')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <img
                                src={getUploadedFileURL(userImageAttachmentId)}
                                alt="user avatar"
                                style={{
                                    border: '1px solid rgba(0, 0, 0, 0.125)',
                                    borderRadius: '4px',
                                    maxWidth: '600px',
                                    maxHeight: '600px',
                                }}
                            ></img>
                        </div>
                    </Modal.Body>
                </Modal>

                <Modal size="lg"
                    show={showMultiTaskModal}
                    onHide={this.handleCloseMultiTaskModal}
                    centered>
                    <Modal.Header>
                        <Modal.Title className="w-100 text-center ApproveModal__title m-0">
                            {t(`${t("Multi Task")} ${t("Timesheet")}`)}
                        </Modal.Title>
                        <img
                            src={CloseModalIcon}
                            className="cursor-pointer"
                            alt='close icon'
                            onClick={this.handleCloseMultiTaskModal}
                        />
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row timelog-grid-time-card">
                            <Col xs={12} md={6}
                                className="timelog-grid-item-1 justify-content-space-between card-timelog-grid-item p-1 mb-2"
                            >
                                <div className="d-flex">
                                    <i className="timelog-grid__icon"></i>
                                    <b >{t('For Date')}</b>
                                </div>
                                <b className="timelog-final-time-card-modal align-self-center">
                                    {currentMultiTaskTimeLogs[0]?.from > currentMultiTaskTimeLogs[0]?.to && currentMultiTaskTimeLogs[0]?.status !== 'draft' ? `${currentMultiTaskTimeLogs[0]?.for_date && shortDateFormat(currentMultiTaskTimeLogs[0]?.for_date, dateTimeRules)} | ${shortDateFormat(moment(currentMultiTaskTimeLogs[0]?.for_date).add(1, 'days'), dateTimeRules)}` : `${currentMultiTaskTimeLogs[0]?.for_date && shortDateFormat(currentMultiTaskTimeLogs[0]?.for_date, dateTimeRules)}`}
                                </b>
                            </Col>
                            <Col xs={12} md={6}
                                className="timelog-grid-item-2 justify-content-space-between card-timelog-grid-item p-1 mb-2"
                            >
                                <div className="d-flex align-items-center">
                                    <i className="timelog-grid__icon"></i>
                                    <b >{t('Total Hours')}</b>
                                </div>
                                <b className="timelog-final-time-card-modal align-self-center">
                                    {totalTimeFormat(currentMultiTaskTimeLogs?.reduce((sum, timelog) => {
                                        const new_data_array = timelog.data ? [timelog.data] : [];
                                        const { totalNormalMinsAll } = allowTimeBank && new_data_array?.length ? getTimebankNormalHours(new_data_array) : 0;
                                        const timeBankTotal = allowTimeBank && new_data_array?.length ? getTimeBankTotalsFromData(new_data_array) : 0;
                                        return sum + (timelog.status !== 'approved' ? (Number(timeBankTotal) || 0) : Math.max(0, Number(timeBankTotal) || 0)) + (timelog.status !== 'approved' ? (Number(timelog.total_hours_normal) || 0) - (Number(totalNormalMinsAll) || 0) : (Number(timelog.total_hours_normal) || 0)) + (Number(timelog.total_hours_overtime) || 0);
                                    }, 0), dateTimeRules)}
                                </b>
                            </Col>
                        </div>
                        <div className="row timelog-grid-time-card">
                            <Col xs={12} md={6} className="timelog-grid-item-1 justify-content-space-between card-timelog-grid-item p-1 mb-2">
                                <div className="d-flex align-items-center">
                                    <i className="timelog-grid__icon"></i>
                                    <b className="cursor-pointer">
                                        {t('Regular Hours')}
                                    </b>
                                </div>
                                <b className="timelog-final-time-card-modal align-self-center">
                                    {totalTimeFormat(currentMultiTaskTimeLogs?.reduce((sum, timelog) => sum + (timelog.status === 'approved' ? (Number(timelog.total_hours_normal) || 0) :
                                        (Number(timelog.total_hours_normal) || 0) - (timelog.data ? getTimebankNormalHours([timelog.data]).totalNormalMinsPositive : 0)), 0), dateTimeRules)}
                                </b>
                            </Col>
                            <Col xs={12} md={6}
                                className="timelog-grid-item-2 justify-content-space-between card-timelog-grid-item p-1 mb-2"
                            >
                                <div className="d-flex align-items-center">
                                    <i className="timelog-grid__icon"></i>
                                    <b>{t('Time bank')} ({t('REG')})</b>
                                </div>
                                <b className="timelog-final-time-card-modal align-self-center">
                                    {totalTimeFormat(totalNormalMinsAll, dateTimeRules)}
                                </b>
                            </Col>
                        </div>
                        <div className="row timelog-grid-time-card">
                            <Col xs={12} md={4}
                                className="timelog-grid-item-1 justify-content-space-between card-timelog-grid-item p-1"
                            >
                                <div className="d-flex">
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip id="overtime-tooltip">
                                                {t('Total Overtime Hours')}
                                            </Tooltip>
                                        }
                                    >
                                        <div className="d-flex align-items-center cursor-pointer">
                                            <i className="timelog-grid__icon"></i>
                                            <b className="small ms-1">{t('Overtime')}</b>
                                        </div>
                                    </OverlayTrigger>
                                </div>
                                <b className="timelog-final-time-card-modal align-self-center small">
                                    {totalTimeFormat(currentMultiTaskTimeLogs?.reduce((sum, timelog) => sum + parseInt(timelog.total_hours_overtime), 0), dateTimeRules)}
                                </b>
                            </Col>
                            <Col xs={12} md={4}
                                className="timelog-grid-item-2 justify-content-space-between card-timelog-grid-item p-1"
                            >
                                <div className="d-flex align-items-center">
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip id="timebank-tooltip">
                                                {t('Overtime hours converted to time bank')}
                                            </Tooltip>
                                        }
                                    >
                                        <div className="d-flex align-items-center cursor-pointer">
                                            <i className="timelog-grid__icon"></i>
                                            <b className="small">
                                                {t('Time bank')} ({t('OT')})
                                            </b>
                                        </div>
                                    </OverlayTrigger>
                                </div>
                                <b className="timelog-final-time-card-modal align-self-center small">
                                    {totalTimeFormat(timeBankMins - totalNormalMinsAll, dateTimeRules)}
                                </b>
                            </Col>
                            <Col xs={12} md={4}
                                className="timelog-grid-item-3 justify-content-space-between card-timelog-grid-item p-1">
                                <div className="d-flex align-items-center">
                                    <i className="timelog-grid__icon"></i>
                                    <b className="small">{t('Break')}</b>
                                </div>
                                <b className="timelog-final-time-card-modal align-self-center small">
                                    {totalTimeFormat(currentMultiTaskTimeLogs?.reduce((sum, timelog) => sum + parseInt(timelog.break || 0), 0), dateTimeRules)}
                                </b>
                            </Col>
                        </div>
                        <div className='multi-log-list' style={{ maxHeight: '60dvh', overflow: 'hidden auto' }}>
                            <GenericList
                                columns={[
                                    {
                                        Header: 'Project',
                                        id: 'project_name',
                                        accessor: ({ project_name }) => (
                                            <span>{`${project_name || ''}`}</span>
                                        ),
                                        maxWidth: 60,
                                        minWidth: 60,
                                        isSortable: !config?.client?.data?.basicRules?.allowMutiTaskTimesheets,
                                        textAlign: 'start'
                                    },
                                    {
                                        Header: 'Task',
                                        id: 'tasks.name',
                                        accessor: ({ task_name }) => (
                                            <span>{`${task_name || ''}`}</span>
                                        ),
                                        maxWidth: 60,
                                        minWidth: 60,
                                        isSortable: !config?.client?.data?.basicRules?.allowMutiTaskTimesheets,
                                        textAlign: 'start'
                                    },
                                    {
                                        Header: 'Time',
                                        id: 'from',
                                        accessor: ({ id, project_id, task_id, distance_type, from, to, break: breakTime, for_date, status, anomaly, data, user_id, is_manually_managed, shift, gps_data, tracker_status }) => {
                                            const isManualOvertime = !(config?.client?.data?.basicRules?.overtimeAutomaticMode || config?.client?.allow_company_shifts) && data?.overtimes && Object.values(data?.overtimes).length > 0
                                            const isSystemEntry = (gps_data && gps_data.systemEntry) ? gps_data.systemEntry : false;
                                            const disableQuickTimesheetEdit = isSystemEntry || status !== 'active';

                                            return <div>
                                                <OverlayTrigger
                                                    trigger={['hover', 'focus']}
                                                    placement="top"
                                                    overlay={
                                                        <Tooltip id={`shift-tooltip-${id}`}>
                                                            {!!shift?.id ? (
                                                                <div style={{ textAlign: 'left' }}>
                                                                    <div><strong>{t('Shift')}</strong></div>
                                                                    <div>{t('Start Time')}: {timeFormat(shift.start_time, dateTimeRules)}</div>
                                                                    <div>{t('End Time')}: {timeFormat(shift.end_time, dateTimeRules)}</div>
                                                                </div>
                                                            ) : (
                                                                <div>{t('No shift found')}</div>
                                                            )}
                                                        </Tooltip>
                                                    }
                                                >
                                                    <span className="cursor-pointer me-1">
                                                        <i className={`fa fa-clock-o ${shift?.id ? 'text-info' : 'text-muted'}`} />
                                                    </span>
                                                </OverlayTrigger>
                                                <OverlayTrigger
                                                    trigger={['hover', 'focus']}
                                                    placement="top"
                                                    overlay={
                                                        <Tooltip id={`edit-time-tooltip-${id}`}>
                                                            {isSystemEntry
                                                                ? t('Cannot edit time as its system entry')
                                                                : status === 'approved'
                                                                    ? t('Cannot edit time as its approved')
                                                                    : status === 'rejected'
                                                                        ? t('Cannot edit time as its rejected')
                                                                        : status === 'draft'
                                                                            ? t('Cannot edit started timesheet')
                                                                            : t('Edit Time')}
                                                        </Tooltip>
                                                    }
                                                >
                                                    <span className={!disableQuickTimesheetEdit ? 'cursor-pointer custom-theme-blue-color fw-bold' : 'fw-bold'}
                                                        onClick={() => {
                                                            if (disableQuickTimesheetEdit) return;
                                                            if (conflictedTimelog) {
                                                                this.handleShowConflict(conflictedTimelog);
                                                                return;
                                                            }
                                                            this.handleShowEditTimeModal({ id, user_id, project_id, task_id, distance_type, from, to, for_date, breakTime, data, is_manually_managed, isManualOvertime, gps_data, tracker_status })
                                                        }}>
                                                        {timeFormat(from, dateTimeRules)} -  {timeFormat(to, dateTimeRules)}
                                                    </span>
                                                </OverlayTrigger>
                                            </div>
                                        },
                                        maxWidth: 80,
                                        minWidth: 60,
                                    },
                                    {
                                        Header: 'Break',
                                        id: 'break',
                                        accessor: ({ timelogBreak }) => (
                                            <span >
                                                {totalTimeFormat(timelogBreak, dateTimeRules)}
                                            </span>
                                        ),
                                        maxWidth: 40,
                                        minWidth: 30,
                                    },
                                    {
                                        Header: 'Total Hours',
                                        id: 'total_hours_normal',
                                        accessor: ({ total_hours_normal, total_hours_overtime, data, status }) => {
                                            const new_data_array = data ? [data] : [];
                                            const { totalNormalMinsAll } = allowTimeBank && new_data_array?.length ? getTimebankNormalHours(new_data_array) : 0;
                                            const timeBankTotal = allowTimeBank && new_data_array?.length ? getTimeBankTotalsFromData(new_data_array) : 0;
                                            const total = (status !== 'approved' ? (Number(timeBankTotal) || 0) : Math.max(0, Number(timeBankTotal) || 0)) + (status !== 'approved' ? (Number(total_hours_normal) || 0) - (Number(totalNormalMinsAll) || 0) : (Number(total_hours_normal) || 0)) + (Number(total_hours_overtime) || 0);
                                            return (
                                                <span className='d-flex justify-content-start'>
                                                    {totalTimeFormat(total, dateTimeRules)}
                                                    {renderOvertimeSymbol(data, t, allow_company_shifts)}
                                                </span>
                                            )
                                        },
                                        maxWidth: 40,
                                        minWidth: 30,
                                    },
                                    allowTimeBank ?
                                        {
                                            Header: 'OT | TB',
                                            id: '_total_hours_overtime',
                                            title: `${t('Overtime')} ${t('and')} ${t('Timebank')}`,
                                            accessor: ({ data, _total_hours_overtime, total_hours_overtime, ismultitasklog, is_manually_managed, isOvertimeCommentMissing }) => {
                                                const data_array = data ? [data] : [];
                                                const timeBankTotal = allowTimeBank && data_array?.length ? getTimeBankTotalsFromData(data_array) : null;
                                                if (allowTimeBank) {
                                                    return (
                                                        <div className='d-flex justify-content-center align-items-center'>
                                                            {isOvertimeCommentMissing &&
                                                                <OverlayTrigger
                                                                    placement="top"
                                                                    overlay={
                                                                        <Tooltip id="tooltip-top">
                                                                            {t('Comment for overtime is missing')}
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <i className="fa fa-exclamation-triangle text-warning" aria-hidden="true"></i>
                                                                </OverlayTrigger>
                                                            }
                                                            {is_manually_managed &&
                                                                <OverlayTrigger
                                                                    placement="top"
                                                                    overlay={
                                                                        <Tooltip id="tooltip-top">
                                                                            {allowAutomaticFlexitimeTimeBank ? t("Mandatory overtime/flexitime") : t("Mandatory overtime")}
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <i className="fa fa-info-circle text-info" aria-hidden="true"></i>
                                                                </OverlayTrigger>
                                                            }
                                                            {(data.overtimes || is_manually_managed || total_hours_overtime) ?
                                                                !ismultitasklog ?
                                                                    <OverlayTrigger
                                                                        key="timesheet_status"
                                                                        placement="top"
                                                                        overlay={
                                                                            <Tooltip id="tooltip-top">
                                                                                {this.getOvertime(data, dateTimeRules, ismultitasklog, total_hours_overtime, _total_hours_overtime,)}
                                                                            </Tooltip>
                                                                        }
                                                                    >
                                                                        <div className='text-center' style={{ fontSize: '10px', lineHeight: '10px', }}>
                                                                            {total_hours_overtime ? totalTimeFormat(total_hours_overtime, dateTimeRules) : <span>-</span>}
                                                                        </div>
                                                                    </OverlayTrigger>
                                                                    :
                                                                    this.getOvertime(data, dateTimeRules, ismultitasklog, total_hours_overtime, _total_hours_overtime)
                                                                :
                                                                overtimeAutomaticMode && !allow_company_shifts ?
                                                                    this.getOvertime(data, dateTimeRules, ismultitasklog, total_hours_overtime, _total_hours_overtime)
                                                                    : '-'
                                                            }
                                                            &nbsp;|&nbsp;
                                                            <div className='text-center' style={{ fontSize: '10px', lineHeight: '10px', }}>
                                                                {timeBankTotal ? totalTimeFormat(timeBankTotal, dateTimeRules) : '-'}
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            },
                                            maxWidth: 90,
                                            minWidth: 80,
                                        } :
                                        {
                                            Header: 'Overtime',
                                            id: 'total_hours_overtime',
                                            accessor: ({ data, _total_hours_overtime, is_manually_managed, total_hours_overtime, isOvertimeCommentMissing }) => (
                                                <div className='d-flex justify-content-center align-items-center flex-column'>
                                                    {isOvertimeCommentMissing &&
                                                        <OverlayTrigger
                                                            placement="top"
                                                            overlay={
                                                                <Tooltip id="tooltip-top">
                                                                    {t('Comment for overtime is missing')}
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <i className="fa fa-exclamation-triangle text-warning me-1" aria-hidden="true"></i>
                                                        </OverlayTrigger>
                                                    }
                                                    {is_manually_managed &&
                                                        <OverlayTrigger
                                                            placement="top"
                                                            overlay={
                                                                <Tooltip id="tooltip-top">
                                                                    {allowAutomaticFlexitimeTimeBank ? t("Mandatory overtime/flexitime") : t("Mandatory overtime")}
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <i className="fa fa-info-circle text-info me-1" aria-hidden="true"></i>
                                                        </OverlayTrigger>
                                                    }
                                                    <>
                                                        <OvertimeDisplay
                                                            data={data ? data.overtimes : null}
                                                            dateTimeRules={dateTimeRules}
                                                            config={config}
                                                            total_hours_overtime={total_hours_overtime}
                                                            ismultitasklog={null}
                                                            _total_hours_overtime={_total_hours_overtime}
                                                            t={t}
                                                        />
                                                        <WeeklyOvertimeDisplay
                                                            data={data}
                                                            total_hours_overtime={total_hours_overtime}
                                                            ismultitasklog={null}
                                                            dateTimeRules={dateTimeRules}
                                                            t={t}
                                                        />
                                                    </>
                                                </div>
                                            ),
                                            maxWidth: 80,
                                            minWidth: 70,
                                        },
                                    {
                                        Header: 'Actions',
                                        id: 'actions',
                                        sortable: false,
                                        accessor: (full) => this.renderTableActionButtons(full.id, full),
                                        maxWidth: 120,
                                        minWidth: 100,
                                    },
                                ]}
                                requestData={() => this.props.timelogStore.forDateLoadList(parseInt(selectedUserId), selectedForDate)}
                                key={this.state.multiTaskReloadKey}
                                pageSize={20}
                            >
                            </GenericList>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        {conflictedTimelog ?
                            <OverlayTrigger key="reset-btn" placement='top'
                                overlay={<Tooltip id='tooltip-resolve-conflicts'>
                                    {t('Please resolve conflicts to approve timesheet')}
                                </Tooltip>}
                            >
                                <Button fill dynamic_lg me2
                                    onClick={() => {
                                        this.handleShowConflict(conflictedTimelog)
                                    }}
                                >
                                    {t("Resolve Conflicts")}
                                </Button>
                            </OverlayTrigger> : <></>
                        }
                        {
                            user_type !== 'member' && !(currentMultiTaskTimeLogs.every(ele => ele.status === currentMultiTaskTimeLogs[0].status) || currentMultiTaskTimeLogs.some(ele => ele.status === 'draft')) ?
                                <OverlayTrigger key="reset-btn" placement='top'
                                    overlay={<Tooltip id='tooltip-reset'>
                                        {isSelfBlockedMultiTask ? selfApprovalMessage : t('Please reset all timelogs before making other changes.')}
                                    </Tooltip>}
                                >
                                    <Button variant="warning" fill dynamic_lg me2 onClick={this.resetAllLogs} disabled={isSelfBlockedMultiTask}>
                                        {t('Reset Timelogs')}
                                    </Button>
                                </OverlayTrigger> : <></>
                        }
                        {
                            !conflictedTimelog && user_type !== 'member' &&
                                currentMultiTaskTimeLogs.every(ele => ele.status === currentMultiTaskTimeLogs[0].status) ||
                                currentMultiTaskTimeLogs.some(ele => ele.status === 'draft') ?
                                <OverlayTrigger
                                    key="user-uploded-img"
                                    placement="top"
                                    overlay={<Tooltip id="tooltip-top">
                                        {currentMultiTaskTimeLogs.some(ele => ele.status === 'draft') ?
                                            t('Cannot proceed to Accept/reject if timelog is in draft') :
                                            t(`${t("Proceed")} ${t("To")} ${t("Accept/reject")}`)}
                                    </Tooltip>}
                                >
                                    <Button fill dynamic_lg me2
                                        onClick={() => this.setState({ showMultiTaskModalAccept: true })}
                                        disabled={currentMultiTaskTimeLogs.some(ele => ele.status === 'draft')}
                                    >
                                        {`${t("Proceed")} ${t("To")} ${t("Accept/reject")}`}
                                    </Button>
                                </OverlayTrigger> : <></>
                        }
                        <Button variant="secondary"
                            onClick={this.handleCloseMultiTaskModal}
                        >
                            {t("Close")}
                        </Button>
                    </Modal.Footer>
                </Modal >

                <Modal
                    className={`modal right fade modal_revised`}
                    size="lg"
                    show={showMultiTaskModalAccept}
                    onHide={() => this.setState({ showMultiTaskModalAccept: false })}
                    centered>
                    <Modal.Header>
                        <Modal.Title className="w-100 text-center ApproveModal__title m-0">
                            {t(`${t("Multi Task")} ${t("Accept/reject")}`)}
                        </Modal.Title>
                        <img
                            src={CloseModalIcon}
                            className="cursor-pointer"
                            alt='close icon'
                            onClick={() => this.setState({ showMultiTaskModalAccept: false, showMultiTaskModal: false, modalInitialTab: null })}
                        />
                    </Modal.Header>
                    <Modal.Body>
                        <MultiTaskModalAccept
                            selectedUserId={selectedUserId}
                            selectedForDate={selectedForDate}
                            closeModal={() => { this.handlePageChange(this.state.page, true); this.props.timelogStore.resetLastListLoadTime(new Date()); this.setState({ showMultiTaskModalAccept: false, showMultiTaskModal: false, modalInitialTab: null }); }}
                            initialTab={this.state.modalInitialTab}
                        />
                    </Modal.Body>
                </Modal>

                {
                    showConflictsModal.showModal &&
                    <TimelogConflictsModal
                        showModal={showConflictsModal.showModal}
                        conflicts={showConflictsModal.conflicts}
                        handleCloseConflictsModal={this.handleCloseConflictsModal}
                        handleShowConflict={this.handleShowConflict}
                        onSaved={() => {
                            this.handlePageChange(this.state.page, true);
                            this.props.timelogStore.resetLastListLoadTime(new Date());
                        }}
                    />
                }

                <EditTimesheetTimeModal
                    show={this.state.showEditTimeModal}
                    onHide={this.handleCloseEditTimeModal}
                    editTimelogId={this.state.editTimelogId}
                    editTimelogData={this.state.editTimelogData}
                    page={this.state.page}
                    message={t('Please edit the time and submit it to update the timesheet.')}
                    onSaved={(timelog) => {
                        if (this.state.showMultiTaskModal) {
                            const parentId = this.state.multiTaskParentId;
                            this.props.timelogStore.resetLastListLoadTime(new Date());
                            this.setState({ ...this.state, showEditTimeModal: false, editTimelogId: null, editTimelogData: null, showMultiTaskModal: false, page: this.state.page, isPageAddedOrEdited: true }, () => {
                                this.handleOpenMultiTaskModal(timelog.user_id, timelog.for_date, parentId)
                            })
                        } else {
                            this.handlePageChange(this.state.page, true);
                            this.props.timelogStore.resetLastListLoadTime(new Date());
                        }
                    }}
                />

                <UserPromptModal
                    source={userPromptModal.source}
                    header={userPromptModal.header}
                    showModal={userPromptModal.showModal}
                    sourceInfo={userPromptModal.sourceInfo}
                    actions={userPromptModal.actions}
                    actionMethods={userPromptModal.actionMethods}
                />
            </Fragment >
        );
    }
}
export default inject(
    'timelogStore',
    'userStore',
    'commonStore',
    'absenceStore'
)(applicationRouter(withLocalization(withRemoveDialog(observer(TimelogsList)))));
